export default (props, e) => {
  e.stopPropagation();
  const {
    actionTarget,
  } = props;
  const { target } = e;

  if (actionTarget) {
    document.querySelector(actionTarget).scrollIntoView({ behavior: 'smooth' });
    target.remove();
  } else {
    target.scrollIntoView({ behavior: 'smooth' });
    target.remove();
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/anchorScroll.js